export const NAME = "dashboard";
